import React, { HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { ErrorBar } from './ErrorBar';
import ContentWrap from '../../../../ui/components/Layout/ContentWrap';
import Responsive from '../../../../ui/utils/Responsive';

interface IErrorBarFooterProps extends HTMLAttributes<HTMLDivElement> {}

export const ErrorBarFooter = ({ children, ...rest }: IErrorBarFooterProps) => {
	const content = <Wrap>{children}</Wrap>;

	return (
		<>
			<ErrorBarSpacer aria-hidden>{content}</ErrorBarSpacer>
			<StyledErrorBarFooter role="alert" {...rest}>
				{content}
			</StyledErrorBarFooter>
		</>
	);
};

const Wrap = styled(ContentWrap)``;

const ErrorBarSpacer = styled(ErrorBar)`
	visibility: hidden;
`;

const StyledErrorBarFooter = styled(ErrorBar)`
	margin-bottom: -40px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		position: fixed;
		margin-bottom: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}
`;
